export enum LumiMode {
  HELP_REQUEST = 'help_request',
  POLARIX_HELP = 'polarix_help',
  PROJECT_HELP = 'project_help',
  HOME = 'home',
  HISTORY = 'history',
  INFO = 'info',
  SUPPORT_MESSAGES = 'support_messages',
}
